var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconAnalytics = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fill: "#0077FF",
  fillOpacity: 0.15
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_10179_17385)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.3373 3H3.66274C3.29744 3 3 3.29744 3 3.66274V20.3373C3 20.7026 3.29744 21 3.66274 21H20.3373C20.7026 21 21 20.7026 21 20.3373V3.66274C21 3.29744 20.7026 3 20.3373 3ZM19.6745 4.32548V19.6745H4.32548V4.32548H19.6745Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.04573 8.26678H10V7H7.52287C7.23466 7 7 7.28427 7 7.63339V11H8.04573V8.26678Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.52287 17H10V15.9835H8.04573V14H7V16.4917C7 16.7719 7.23466 17 7.52287 17Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 16.3666V13H15.9543V15.7332H14V17H16.4771C16.7653 17 17 16.7157 17 16.3666Z",
  fill: "#1160FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9543 10H17V7.50827C17 7.22811 16.7653 7 16.4771 7H14V8.01654H15.9543V10Z",
  fill: "#1160FF"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_10179_17385"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(3 3)"
})))));
export default SvgIconAnalytics;